// @ts-check
import api from 'utils/api';
import { decamelizeKeys } from 'humps';

const actions = {
  changePassword(formValues) {
    return api.patch('/agent_portal/api/current_agent/update_password', {
      agent: decamelizeKeys(formValues),
    });
  },
};

export default actions;
